





















import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Header extends Vue {
    public home() {
        this.$router.push('/');
    }

    public about() {
        this.$router.push('/about');
    }

    public howitworks() {
        this.$router.push('/howitworks');
    }
}
